import React, { useEffect } from "react";
import { X } from "lucide-react";

import CandidateProfileEditContent from "./CandidateProfileEditContent";
import "./CandidateProfileEdit.css";

/**
 * Full-screen dialog for editing candidate profile from career journey.
 */
const CandidateProfileEditDialog = ({ isOpen, onClose, userId, onSaved }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen || !userId) return null;

  return (
    <div className="cpe-profile-dialog-overlay" onClick={onClose}>
      <div
        className="cpe-profile-dialog"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cpe-profile-dialog-title"
      >
        <div className="cpe-profile-dialog-header">
          <h2 id="cpe-profile-dialog-title" className="cpe-profile-dialog-title">
            Edit Candidate Profile
          </h2>
          <button
            type="button"
            className="cpe-profile-dialog-close"
            onClick={onClose}
            aria-label="Close profile editor"
          >
            <X size={22} />
          </button>
        </div>
        <div className="cpe-profile-dialog-body">
          <CandidateProfileEditContent
            userId={userId}
            variant="dialog"
            onSaved={onSaved}
          />
        </div>
      </div>
    </div>
  );
};

export default CandidateProfileEditDialog;
